import React from 'react';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import RegisterMode from '../../Types/RegisterMode';
import RegisterSuccess from './ui/RegisterSuccess';
import RegisterForm from './ui/RegisterForm';
import styled from 'styled-components';
import { getColor } from '../../styling/mixins/colors';
import { text } from '../../styling/mixins/typography';
import RegisterProps from './types/RegisterProps';

const StyledRegisterError = styled.div`
  ${text('medium')}
  color: ${getColor('alert')};
  margin-bottom: 1.6rem;
`;

const RegisterContainer = (props: RegisterProps) => {
  const { registerMode, error } = useTypedSelector((state) => state.register);

  return (
    <>
      {registerMode == RegisterMode.Register && <RegisterForm {...props} />}
      {registerMode == RegisterMode.RegisterSuccess && <RegisterSuccess {...props} />}
      {error && <StyledRegisterError>{error}</StyledRegisterError>}
    </>
  );
};

export default RegisterContainer;
